import React from 'react';
import useStore from '../store/useStore';
import '../css/custom.css';
import myImage from '../images/men_image.png';

function WallContainer({ maxLEDWidth, maxLEDHeight, wallContainerWidth, wallContainerHeight, panelDetails }) { 

    const unit = useStore((state) => state.unit);
    
    const wallWidth = useStore((state) => state.wallWidth);
    const wallHeight = useStore((state) => state.wallHeight);

    // Wall container style
    const wallContainerStyle = {
        width: `${wallContainerWidth}px`,
        height: `${wallContainerHeight}px`,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        border: '0px solid black',
        position: 'relative',
        background: '#dae1df',
    };

    // Tile Style
    const tileStyle = {
        width: `${wallContainerWidth * panelDetails.panelWidth / wallWidth}px`,
        height: `${wallContainerHeight * panelDetails.panelHeight / wallHeight}px`,
        background: '#215EAC',
        border: '0.5px solid white',
    };

    // Styles for width markers
    const widthMarkerStyle = (position) => ({
        position: 'absolute',
        top: '-47px', // Adjust as necessary
        left: `${position}px`,
        fontSize: '12px', // Adjust size as needed
        padding: '5px',
        borderRadius: '7px',
        background: 'gray',
        color: '#fff'
    });

    // Styles for height markers
    const heightMarkerStyle = (position) => ({
        position: 'absolute',
        top: `${position}px`,
        left: '-67px', // Adjust as necessary
        fontSize: '12px', // Adjust size as needed
        padding: '5px',
        borderRadius: '7px',
        background: 'gray',
        color: '#fff'
    });

        // Styles for height markers
    const ScaleMarkerStyle = {
        width: ``, //maxLEDHeight
        height: `${(1.83 / ((wallHeight * 0.3048).toFixed(2))) * wallContainerHeight}px`,
        position: 'absolute',
        bottom: '0px', // Align with the bottom of the wallContainerStyle
        right: `${-((1.83 / ((wallWidth * 0.3048).toFixed(2))) * wallContainerWidth)/2 + 5}px`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end', // Align items to the end of the container (bottom)
    };

    const imageStyle = {
        width: ``, //maxLEDHeight
        height: `${(1.83 / ((wallHeight * 0.3048).toFixed(2))) * wallContainerHeight}px`,
    }

    const scaleTagStyle = {
        position: 'absolute', // Absolute positioning relative to its nearest positioned ancestor
        bottom: '-28px', // Position the text below the image border
        width: '100%', // Ensure the text spans the width of its container
        textAlign: 'center', // Center-align the text
        fontSize: '10px', // Adjust as necessary
        color: '#000', // Text color
    };

    const rulerwidthStyle = {
        width: `${wallContainerWidth * panelDetails.panelWidth / wallWidth * (maxLEDWidth / panelDetails.panelWidth)?.toFixed(0)}px`,
        height: `${((wallContainerHeight - (wallContainerHeight * panelDetails.panelHeight / wallHeight * (maxLEDHeight / panelDetails.panelHeight))) / 2) + 13}px`,
        position: 'absolute',
        top: '-13px',
        borderLeft: '1px dashed red',
        borderRight: '1px dashed red',
        borderTop: '1px solid gray',
    };
    
    const rulerheightStyle = {
        height: `${wallContainerHeight * panelDetails.panelHeight / wallHeight * (maxLEDHeight / panelDetails.panelHeight)?.toFixed(0)}px`,
        width: `${((wallContainerWidth - (wallContainerWidth * panelDetails.panelWidth / wallWidth * (maxLEDWidth / panelDetails.panelWidth))) / 2) + 13}px`,
        position: 'absolute',
        border: 'none',
        left: '-13px',
        borderTop: '1px dashed red',
        borderBottom: '1px dashed red',
        borderLeft: '1px solid gray',
    };

    const maxLEDWidthInTiles = Math.min((maxLEDWidth / panelDetails.panelWidth)?.toFixed(0), (wallWidth)); // Ensure the LED width doesn't exceed the wall width
    const maxLEDHeightInTiles = Math.min((maxLEDHeight / panelDetails.panelHeight)?.toFixed(0), (wallHeight)); // Ensure the LED height doesn't exceed the wall height

    // Generate the wall tiles based on the width and height values
    const generateWall = () => {

        let tiles = [];

        // Generate ruler for width
        let widthRuler = [];
        widthRuler.push(<div key={`width-ruler`} style={rulerwidthStyle} className="dotStyleW"></div>);
        tiles.push(<div key="width-ruler" className="d-flex">{widthRuler}</div>);
        
        // Generate ruler for height
        let heightRuler = [];
        heightRuler.push(<div key={`height-ruler`} style={rulerheightStyle} className="dotStyleH"></div>);
        tiles.push(<div key="height-ruler" className="d-flex flex-row-reverse">{heightRuler}</div>);
        
        for(let i = 0; i < Math.min((maxLEDHeight / panelDetails.panelHeight)?.toFixed(0), maxLEDHeightInTiles); i++) {
            let row = [];
            for(let j = 0; j < Math.min((maxLEDWidth / panelDetails.panelWidth)?.toFixed(0), maxLEDWidthInTiles); j++) {
                row.push(<div key={`${i}-${j}`} style={tileStyle}></div>);
            }
            tiles.push(<div key={i} className="d-flex">{row}</div>);
        }
        return tiles;
    };

    return (
        <div id="wall-background">
            <div style={wallContainerStyle}>
                    {(wallHeight * 0.3048).toFixed(2) >= 1.83  && maxLEDWidthInTiles !== 0 ? (
                      <div style={ScaleMarkerStyle}>
                        <img style={imageStyle} src={myImage} alt="scale" />
                        <span style={scaleTagStyle}>183 cm</span>
                      </div>
                    ) : null}
                <div style={widthMarkerStyle(wallContainerWidth / 2 - 20)}>{(unit === 'ft' ? maxLEDWidth : maxLEDWidth  * 0.3048)?.toFixed(2)} {unit}</div>
                <div style={heightMarkerStyle(wallContainerHeight / 2 - 10)}>{(unit === 'ft' ? maxLEDHeight : maxLEDHeight  * 0.3048)?.toFixed(2)} {unit}</div>
                <div>{generateWall()}</div>
            </div>
        </div>
    );
}

export default WallContainer;
